import { api } from '../../api'

const makeParams = ({ years, projects, users, download_mode }) => {
  const params = new URLSearchParams()

  projects.forEach(({ id }) => {
    params.append('project_ids[]', id)
  })
  users.forEach(({ id }) => {
    params.append('user_ids[]', id)
  })
  years.forEach(({ value }) => {
    params.append('years[]', value)
  })

  if (download_mode) {
    params.append('download_mode', 1)
  }

  return params
}

export const departmentProjectsApi = api
  .enhanceEndpoints({
    addTagTypes: ['department-projects'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getRentByProjAndDepart: builder.query({
        providesTags: ['department-projects'],
        query: ({ years, projects, users }) => ({
          url: '/profitability/projects',
          method: 'GET',
          params: makeParams({ years, projects, users }),
        }),
        transformResponse: (response) => response?.data || [],
      }),
      getDepartmentProjectsReport: builder.mutation({
        query: ({ years, projects, users }) => ({
          url: '/profitability/projects',
          method: 'GET',
          params: makeParams({ years, projects, users, download_mode: 1 }),
          responseHandler: async (response) => response.blob(),
        }),
      }),
    }),
  })

export const {
  useLazyGetRentByProjAndDepartQuery,
  useGetDepartmentProjectsReportMutation,
} = departmentProjectsApi
